<script>
    import Swal from "sweetalert2";
    import ModalEditAutomatedNotificationAttributes
      from "@/components/modals/notification/modalEditAutomatedNotificationAttributes.vue";

    export default {
      components: {ModalEditAutomatedNotificationAttributes},
        props: ['notificationData'],
        data() {
            return {
                type: [],
                type_e: [], // Initialize as an array
                attributes: [],
                attributesData:[],
                title: '',
                isBusy: false,
                currentPage: 1,
                perPage: 10,
                totalRows: 0,
                tableData: [],
                pageOptions: [10, 25, 50, 100],
                selectedType: '',
                filter: null,
                filterOn: [],
                sortBy: "valid_from",
                sortDesc: true,
                message: '',
                showModal: false,
                submitted: false,
                tryingToSubmit: false,
                showLoader: false,
                csrf_token: localStorage.getItem("csrf_token"),
                error: null,
                fields: [
                  {
                    key: "attribute",
                    label: "Attribute",
                  },
                  {
                    key: "value",
                    label: "Value",
                  },
                  {
                    key:"action",
                    label:"Actions",
                  }
                ],
            };
        },

      watch: {
        notificationData: {
          handler(newVal) {
            this.attributes = newVal || []
          },
          immediate: true
        }
      },
        methods: {
            closeModal() {
                this.showModal = false;
                this.submitted = false;
            },
          callModalEditAttributes(data) {
            this.$bvModal.show("edit_automated_notification_attributes");
            this.attributesData = data
          },


            successmsg(message) {
                Swal.fire("Success", message, "success");
            },

            failedmsg(message) {
                Swal.fire("Error", message, "error");
            },

            refreshData() {
                this.$emit("onRefresh");
            },

            resetProps(){
              this.tableData = [];
              this.totalRows = 0;
              this.currentPage = 1;
              this.perPage = 10;
              this.filter = null;
              this.filterOn = [];
              this.sortBy = "valid_from";
              this.sortDesc = true;
              this.attributes = [];
              this.showModal = false;
            },

            modalShown(){
              this.attributes = this.notificationData;
              console.log(this.attributes,'attributes');
              this.tableData = this.attributes;
              console.log(this.tableData,'tableData');
              this.totalRows = this.attributes.length;
            }
        },
    };
</script>

<template>
    <b-modal @shown="modalShown" id="view_notifications_attributes" size="xl" v-model="showModal" @hidden="resetProps"  title="View Notifications Attributes" title-class="font-18">
      <div class="table-responsive mb-0 font-size-12">
        <b-table
            :items="tableData"
            :busy="isBusy"
            :fields="fields"
            :visible="fields.visible"
            responsive="sm"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :filter="filter"
            :filter-included-fields="filterOn"
            show-empty
            empty-text="No Data Found"
        >
<!--          Temporary commented -->
<!--          <template v-slot:cell(action)="data">-->
<!--            <ul v-if="data.item.value_editable" class="list-inline mb-0">-->
<!--              <li class="list-inline-item">-->
<!--                <a href="javascript:void(0);" class="px-2 text-primary" title="Edit Notifications Attributes" @click="callModalEditAttributes(data.item)">-->
<!--                  <i class="uil uil-pen font-size-18"></i>-->
<!--                </a>-->
<!--              </li>-->
<!--            </ul>-->
<!--          </template>-->
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>

        </b-table>
      </div>
      <div class="row">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-end">
            <ul class="pagination pagination-rounded mb-0">
              <!-- pagination -->
              <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div>
      <ModalEditAutomatedNotificationAttributes :attributesData="attributesData"></ModalEditAutomatedNotificationAttributes>
    </b-modal>
</template>
